// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.md_preview {
    flex: 1;
    overflow: auto;
    padding: 20px 28px;
    /* font-size set inline from fontSize prop */
    line-height: 1.65;
    color: var(--color-text);
}

.md_preview h1,
.md_preview h2,
.md_preview h3,
.md_preview h4,
.md_preview h5,
.md_preview h6 {
    margin: 18px 0 8px;
    font-weight: 600;
    line-height: 1.3;
    color: var(--color-text);
}

.md_preview h1 { font-size: 1.6em; }
.md_preview h2 { font-size: 1.3em; border-bottom: 1px solid var(--color-border); padding-bottom: 6px; }
.md_preview h3 { font-size: 1.1em; }
.md_preview h4,
.md_preview h5,
.md_preview h6 { font-size: 1em; }

.md_preview p {
    margin: 8px 0;
}

.md_preview code {
    background: var(--color-bg-3);
    padding: 1px 5px;
    border-radius: 3px;
    font-family: monospace;
    font-size: 0.9em;
}

.md_preview pre {
    background: var(--color-bg-3);
    border: 1px solid var(--color-border);
    border-radius: 4px;
    padding: 12px 16px;
    overflow-x: auto;
    margin: 12px 0;
}

.md_preview pre code {
    background: none;
    padding: 0;
    font-size: 0.95em;
    line-height: 1.5;
}

.md_preview blockquote {
    border-left: 3px solid var(--color-accent, #3498db);
    margin: 10px 0;
    padding: 4px 14px;
    color: var(--color-text-muted);
}

.md_preview ul,
.md_preview ol {
    margin: 8px 0;
    padding-left: 24px;
}

.md_preview li {
    margin: 3px 0;
}

.md_preview a {
    color: var(--color-accent, #3498db);
    text-decoration: none;
}

@media (pointer: fine) {
    .md_preview a:hover {
        text-decoration: underline;
    }
}

.md_preview img {
    max-width: 100%;
    height: auto;
}

.md_preview hr {
    border: none;
    border-top: 1px solid var(--color-border);
    margin: 16px 0;
}

.md_preview del {
    opacity: 0.6;
}

.md_preview table {
    border-collapse: collapse;
    width: 100%;
    margin: 12px 0;
    font-size: 0.95em;
}

.md_preview th,
.md_preview td {
    border: 1px solid var(--color-border);
    padding: 6px 12px;
    line-height: 1.4;
}

.md_preview thead tr {
    background: var(--color-bg-3);
}

.md_preview th {
    font-weight: 600;
    color: var(--color-text);
}

.md_preview tbody tr:nth-child(even) {
    background: var(--color-bg-2);
}
`, "",{"version":3,"sources":["webpack://./components/toolkit/MdPreview/s.md_preview.css"],"names":[],"mappings":"AAAA;IACI,OAAO;IACP,cAAc;IACd,kBAAkB;IAClB,4CAA4C;IAC5C,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA;;;;;;IAMI,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA,iBAAiB,gBAAgB,EAAE;AACnC,iBAAiB,gBAAgB,EAAE,4CAA4C,EAAE,mBAAmB,EAAE;AACtG,iBAAiB,gBAAgB,EAAE;AACnC;;iBAEiB,cAAc,EAAE;;AAEjC;IACI,aAAa;AACjB;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,qCAAqC;IACrC,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,mDAAmD;IACnD,cAAc;IACd,iBAAiB;IACjB,8BAA8B;AAClC;;AAEA;;IAEI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mCAAmC;IACnC,qBAAqB;AACzB;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,yCAAyC;IACzC,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,cAAc;IACd,iBAAiB;AACrB;;AAEA;;IAEI,qCAAqC;IACrC,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;IACI,6BAA6B;AACjC","sourcesContent":[".md_preview {\n    flex: 1;\n    overflow: auto;\n    padding: 20px 28px;\n    /* font-size set inline from fontSize prop */\n    line-height: 1.65;\n    color: var(--color-text);\n}\n\n.md_preview h1,\n.md_preview h2,\n.md_preview h3,\n.md_preview h4,\n.md_preview h5,\n.md_preview h6 {\n    margin: 18px 0 8px;\n    font-weight: 600;\n    line-height: 1.3;\n    color: var(--color-text);\n}\n\n.md_preview h1 { font-size: 1.6em; }\n.md_preview h2 { font-size: 1.3em; border-bottom: 1px solid var(--color-border); padding-bottom: 6px; }\n.md_preview h3 { font-size: 1.1em; }\n.md_preview h4,\n.md_preview h5,\n.md_preview h6 { font-size: 1em; }\n\n.md_preview p {\n    margin: 8px 0;\n}\n\n.md_preview code {\n    background: var(--color-bg-3);\n    padding: 1px 5px;\n    border-radius: 3px;\n    font-family: monospace;\n    font-size: 0.9em;\n}\n\n.md_preview pre {\n    background: var(--color-bg-3);\n    border: 1px solid var(--color-border);\n    border-radius: 4px;\n    padding: 12px 16px;\n    overflow-x: auto;\n    margin: 12px 0;\n}\n\n.md_preview pre code {\n    background: none;\n    padding: 0;\n    font-size: 0.95em;\n    line-height: 1.5;\n}\n\n.md_preview blockquote {\n    border-left: 3px solid var(--color-accent, #3498db);\n    margin: 10px 0;\n    padding: 4px 14px;\n    color: var(--color-text-muted);\n}\n\n.md_preview ul,\n.md_preview ol {\n    margin: 8px 0;\n    padding-left: 24px;\n}\n\n.md_preview li {\n    margin: 3px 0;\n}\n\n.md_preview a {\n    color: var(--color-accent, #3498db);\n    text-decoration: none;\n}\n\n@media (pointer: fine) {\n    .md_preview a:hover {\n        text-decoration: underline;\n    }\n}\n\n.md_preview img {\n    max-width: 100%;\n    height: auto;\n}\n\n.md_preview hr {\n    border: none;\n    border-top: 1px solid var(--color-border);\n    margin: 16px 0;\n}\n\n.md_preview del {\n    opacity: 0.6;\n}\n\n.md_preview table {\n    border-collapse: collapse;\n    width: 100%;\n    margin: 12px 0;\n    font-size: 0.95em;\n}\n\n.md_preview th,\n.md_preview td {\n    border: 1px solid var(--color-border);\n    padding: 6px 12px;\n    line-height: 1.4;\n}\n\n.md_preview thead tr {\n    background: var(--color-bg-3);\n}\n\n.md_preview th {\n    font-weight: 600;\n    color: var(--color-text);\n}\n\n.md_preview tbody tr:nth-child(even) {\n    background: var(--color-bg-2);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
